import Axios, { CancelTokenSource } from 'axios';
import React, { useEffect, useState } from 'react';

export const withAxiosCancellation = (WrappedComponent: React.ComponentType | React.FunctionComponent) => {
	return (props: any) => {
		const [source, setSource] = useState<CancelTokenSource>(Axios.CancelToken.source());
		const [isRequestCancelled, setIsRequestCancelled] = useState<boolean>(false);

		// Note - useEffect body till return statement acts as componentDidMount
		//        and function in return statement acts as componentWillUnmount
		//        only when the second argument for useEffect is an empty array.
		useEffect(() => {
			return function cleanUp() {
				// Cancel all requests of axios using source
				source.cancel();
			};
		}, []);

		useEffect(() => {
			if (isRequestCancelled) {
				setSource(Axios.CancelToken.source());
				setIsRequestCancelled(false);
			}
		}, [isRequestCancelled, setSource, setIsRequestCancelled]);

		return (
			<WrappedComponent
				{...props}
				cancelActiveRequests={async () => {
					return new Promise<boolean>((resolve, _) => {
						source.cancel();
						setIsRequestCancelled(true);
						resolve(true);
					});
				}}
				isRequestCancelled={isRequestCancelled}
				axiosCancellationToken={source.token}
			/>
		);
	};
};



// WEBPACK FOOTER //
// ./src/components/core/axios-cancel.component.tsx